import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import styled from 'styled-components';
import * as yup from 'yup';
import FormModalStyled from '../../../../core/components/modals/FormModalStyled';
import withModal from '../../../../core/components/withModals';
import AForm from '../../../../core/components/form/AForm';
import ATextArea from '../../../../core/components/inputs/textArea/ATextArea';
import { hoursCountToTimeString, timeStringToHoursCount } from '../../../../util/util';

const AddNoteModal = (props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { modalProps, modalData, closeDialog, setModifiedData } = props;

  const timeToHoursCount = timeStringToHoursCount(modalData?.timeTo, true);
  const timeFromFormatted = modalData?.timeFrom ? modalData?.timeFrom?.substring(0, 5) : null;
  const timeToFormatted = modalData?.timeTo ? (hoursCountToTimeString(timeToHoursCount, false).substring(0, 5)) : null

  const validationSchema = yup.object().shape({
    comment: yup
        .string()
  });

  const fields = [
    {
      id: 'comment',
      name: t('dailySchedule.note'),
      render: <ATextArea style={{ height: '220px', resize: 'none' }} />
    }
  ];

  const submitHandler = (formData) => {
    setLoading(true);
    if (modalData?.modified) { // ADDING COMMENT TO MODIFIED CARD
      setModifiedData((prevState) => {
        const newStateArray = [...prevState];
        const newestModifiedDataArray = [];
        prevState?.[prevState?.length - 1]?.forEach((el) => {
          if (el?.timeFrom === modalData?.timeFrom && el?.timeTo === modalData?.timeTo && el?.controllerId === modalData?.controllerId && el?.type !== 'REMOVE') {
            newestModifiedDataArray.push({
              controllerId: el?.controllerId,
              timeFrom: el?.timeFrom,
              timeTo: el?.timeTo,
              type: 'ADD',
              sectorId: el?.sectorId,
              minuteFrom: el?.minuteFrom,
              sectorRoleId: el?.sectorRoleId,
              assignment: el?.assignment === 'ŠS/KL' ? 'SHIFT_MANAGER_AND_CONTROLLER' : el?.assignment === 'OJTI/ASSE' ? 'OJTI_AND_ASSE' : el?.assignment,
              comment: formData?.comment
            });
          } else newestModifiedDataArray.push(el);
        });
        newStateArray.push(newestModifiedDataArray);
        return newStateArray;
      });
    } else { // ADDING COMMENT TO NON-MODIFIED CARD
      setModifiedData((prevState) => [
        ...(prevState ? prevState : []),
        [
          ...(prevState?.[prevState?.length - 1] ? prevState?.[prevState?.length - 1] : []),
          {
            controllerId: modalData?.controllerId,
            timeFrom: modalData?.timeFrom,
            timeTo: modalData?.timeTo,
            type: 'REMOVE',
            sectorId: modalData?.sectorId,
            sectorRoleId: modalData?.sectorRoleId,
            assignment: modalData?.assignment,
            minuteFrom: modalData?.minuteFrom,
            comment: modalData?.comment
          },
          {
            controllerId: modalData?.controllerId,
            timeFrom: modalData?.timeFrom,
            timeTo: modalData?.timeTo,
            type: 'ADD',
            sectorId: modalData?.sectorId,
            minuteFrom: modalData?.minuteFrom,
            sectorRoleId: modalData?.sectorRoleId,
            assignment: modalData?.assignment,
            comment: formData?.comment
          }
        ]
      ]);
    }
    setLoading(false);
    closeDialog();
  }

  return (
    <FormModalStyled
      centered
      maskClosable={false}
      width={550}
      footer={[]}
      {...modalProps}
      title={modalData?.comment ? t('dailySchedule.editNote') : t('dailySchedule.addNote')}
    >
      <IntroText>
        Tekstualna napomena za dužnost:
        <br />
        <br />
        {modalData?.controllerFullName + ' ('}
        {(!!modalData?.assignment && modalData?.assignment !== 'REGULAR') ? <b>{(modalData?.assignment === 'SHIFT_MANAGER_AND_CONTROLLER' ? 'ŠS' : modalData?.assignment) + '/'}</b> : null}
        {modalData?.sectorShortName ? <b>{modalData?.sectorShortName}</b> : null}
        {modalData?.sectorRoleShortName ? <b>{' ' + modalData?.sectorRoleShortName}</b> : null}
        ) u periodu
        {' '}
        <b>{timeFromFormatted}</b>
        {' - '}
        <b>{timeToFormatted}</b>
      </IntroText>
      <FormContainer>
        <AForm
          fields={fields}
          modalData={modalData}
          style={{ height: '250px' }}
          okButtonText={t('buttons.save')}
          cancelButtonText={t('buttons.cancel')}
          onCancel={() => {
            closeDialog();
          }}
          disabled={loading}
          validationSchema={validationSchema}
          modalAddHandler={(formData) => submitHandler(formData)}
          modalEditHandler={(formData) => submitHandler(formData)}
          name="add-user-modal-form"
        />
      </FormContainer>
    </FormModalStyled>
  )
};

export default withModal()(AddNoteModal);

const FormContainer = styled.div`
  width: 100%;
  height: 320px;
  position: relative;
  & .aform-footer {
    position: absolute;
    padding-top: 20px;
    padding-bottom: 10px;
    padding-right: 0 !important;
    bottom: 0;
    right: 40px;
  }
`;

const IntroText = styled.div`
  white-space: pre-wrap;
  width: 100%;
  padding: 15px 20px;
`;
